import { render, staticRenderFns } from "./CrudVolunteersList.vue?vue&type=template&id=20f37878&"
import script from "./CrudVolunteersList.vue?vue&type=script&lang=js&"
export * from "./CrudVolunteersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports